module.exports = __webpack_public_path__ + "81eb7ed41c45363ff0253e4f5bc27a3b.mp3";